import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetInvites = (organizationId: string) => {
  const inviteStudentsService = useServices().inviteStudentsService;
  return useQuery({
    queryKey: ['organizationInvites', organizationId],
    queryFn: () => inviteStudentsService.getInvites(organizationId),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
}